if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    connectedCallback() {
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      if (!this.cartTermsCheckbox) return;

      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      if (!this.form) return;

      if (this.form.cartTermsInstance && this.form.cartTermsInstance !== this) {
        this.form.removeEventListener('submit', this.form.cartTermsInstance.submitHandler);
      }

      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.form.cartTermsInstance = this;
    }

    disconnectedCallback() {
      if (!this.form || !this.submitHandler) return;

      this.form.removeEventListener('submit', this.submitHandler);

      if (this.form.cartTermsInstance === this) {
        delete this.form.cartTermsInstance;
      }
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
